import { render, staticRenderFns } from "./safetyHealthObliItem.vue?vue&type=template&id=f6fbfa70"
import script from "./safetyHealthObliItem.vue?vue&type=script&lang=js"
export * from "./safetyHealthObliItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6fbfa70')) {
      api.createRecord('f6fbfa70', component.options)
    } else {
      api.reload('f6fbfa70', component.options)
    }
    module.hot.accept("./safetyHealthObliItem.vue?vue&type=template&id=f6fbfa70", function () {
      api.rerender('f6fbfa70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/obli/safetyHealthObliItem.vue"
export default component.exports